<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">تیکت ها</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

              </CCol>

            </CRow>
          </CCardHeader>
          <CRow>
<CCol col="12">
  <CTextarea v-model="summary" ></CTextarea>
  <CButton
      outline
      color="success"
      @click="send_message()">ارسال پیام</CButton>
</CCol>
            <CCol col="12">
              <CRow >
                <CCol md="6">
                  <CCard>
                    <CCardHeader>
                      <strong>لیست تیکت ها</strong>
                    </CCardHeader>
                    <CCardBody>
<CCard v-for="item in items">
  <CCardHeader :class="item.admin_id==null? '' : 'bg-success'">
    <CRow>
      <CCol v-if="item.admin_id==null">
        پیام کاربر
      </CCol>
      <CCol v-else>
{{item.admin.name}}
      </CCol>
      <CCol>{{get_date_time(item.created_at)}}</CCol>
    </CRow>
    </CCardHeader>
  <CCardBody>{{item.summary}}</CCardBody>
</CCard>
                    </CCardBody>

                  </CCard>
                </CCol>
              </CRow>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
      edit_name:'',
      name: '',
      summary: '',
      price: '',
      old_price: '',
      package_name: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      items: [],
      table_clicks:0,
      table_clicks_timer:null,
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'name', label: "نام", _style: 'width:20%'},
        {key: 'user', label: "کاربر", _style: 'width:20%;'},
        {key: 'status', label:"وضعیت", _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.edit_name = item.brandName;
      this.name = item.brandName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = this.$root.base_url+'/'+item.imageName;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;
      console.log("route id " , this.$route.params.id);

      const formData = new FormData();


      formData.append('id', this.$route.params.id);


      axios.post('/admin_tickets/get_ticket_messages', formData,{}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.items = content_data


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    send_message() {
      var self = this;
      console.log("route id " , this.$route.params.id);

      const formData = new FormData();


      formData.append('token', localStorage.getItem("token"));
      formData.append('message', this.summary);
      formData.append('id', this.$route.params.id);


      axios.post('/admin_tickets/send_ticket_messages', formData,{}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.get_lists()
        self.summary = ""

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: "/dashboard/products/list-brand/" + item.id})
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "hosts";
      } else {
        url = "EditBrand";
        formData.append('id', this.status_form)
      }

      formData.append('summary', this.summary);
      formData.append('name', this.name);
      formData.append('price', this.price);
      formData.append('old_price', this.old_price);
      formData.append('package_name', this.package_name);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);
        bus.$emit('close_add_base_modal', 'false');

      })
          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
